import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { UserRole } from '~types/types';
import { NavigationAddDropdown, NavigationHomeLink, NavigationLink } from './NavigationLink';

const StyledNavBar = styled.div`
  display: flex;
  justify-content: center;
  background-color: #333f48;
`;

interface NavBarProps {
  userRole: UserRole;
}

const NavBar: React.FC<NavBarProps> = ({ userRole }) => {
  const { t } = useTranslation();

  const addOptions = [
    { label: t('pages.add_entry'), href: '/bookkeeping/entry/new' },
    { label: t('pages.add_measurement'), href: '/bookkeeping/measurements?new=true' },
  ];

  return (
    <StyledNavBar>
      <NavigationHomeLink href="/" title="🌍" tooltip={t('pages.dashboard')} />
      {userRole === UserRole.Admin && (
        <NavigationLink href="/admin" title={t('pages.admin.header')} exact={false} />
      )}
      <NavigationLink href="/customers" title={t('pages.customers')} />
      <NavigationLink href="/products" title={t('pages.products')} />
      <NavigationLink href="/tanks" title={t('pages.tanks')} />
      <NavigationLink href="/reports/tank" title={t('pages.reports')} exact={false} />
      <NavigationLink href="/bookkeeping" title={t('pages.bookkeeping')} exact={false} />
      <NavigationAddDropdown title="✚" tooltip={t('pages.add_new')} options={addOptions} />
    </StyledNavBar>
  );
};

export default NavBar;
